// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TInsuranceAcceptModel,
  IMappers,
  TInsuranceAcceptResponse,
  IInsuranceAcceptResponse,
  IInsuranceAcceptResponseError,
} from './types';

export const defaultConfig: TInsuranceAcceptModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'dailyrent',
  pathApi: '/v2/insurance/accept/',
} as TInsuranceAcceptModel;

export function createInsuranceAcceptModel(): TInsuranceAcceptModel {
  return {
    ...defaultConfig,
  };
}

export interface IInsuranceAcceptOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchInsuranceAccept<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IInsuranceAcceptOptions<TResponse200, TResponse400>): Promise<
  TInsuranceAcceptResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createInsuranceAcceptModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IInsuranceAcceptResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IInsuranceAcceptResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TInsuranceAcceptResponse;
}
